import React, { useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import Card from 'react-bootstrap/cjs/Card'
import BSModal from 'react-bootstrap/Modal'
import { _ } from 'utils'

import { CreateJobOpeningRequest } from 'types/swagger'
import { useEventSlug } from 'hooks'
import Icon from 'components/Icon'
import { addModal } from 'features/modals/modalSlice'
import JobForm from './JobForm'
import { Job } from './types'
import { updateJob } from './jobsSlice'

const S = {
    ModalHeader: styled(BSModal.Header)`
        padding: 16px;
    `,
    ModalHeaderInner: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    `,
    ModalBody: styled.div`
        padding: 24px;
    `,
    ModalTitle: styled(BSModal.Title)`
        margin-top: auto;
        margin-bottom: auto;
        font-size: 20px;
        line-height: unset;
        color: #5a5a5a;
        font-weight: bold;
    `,
    Card: styled(Card)`
        padding: 12px;
    `,
    Page: styled.div`
        padding: 24px;
    `,
    Header: styled.div`
        display: flex;
        margin-bottom: 40px;
    `,
    Title: styled.h1`
        font-weight: 500;
        font-size: 20px;
    `,
}

const ViewJob = ({ job }: { job: Job }) => (
    <div dangerouslySetInnerHTML={{ __html: job.description }} />
)

const EditJob = ({ job, close }: { job: Job, close: () => void }) => {
    const dispatch = useDispatch()
    const eventSlug = useEventSlug()

    const save = async (data: CreateJobOpeningRequest) => {
        await dispatch(updateJob({
            id: job.id,
            data,
            eventSlug,
            boothSlug: job.booth.slug,
        }))
        close()
    }

    return <JobForm save={save} job={job} />
}

const ViewEditJob = ({ job, close, ...props }: { isViewing?: boolean, close: () => void, job: Job }) => {
    const [isViewing, setViewing] = useState(props.isViewing || false)

    const title = isViewing
        ? _('booth.jobs.modal_title.view')
        : _('booth.jobs.modal_title.edit')

    return (
        <>
            <S.ModalHeader>
                <S.ModalHeaderInner>
                    <S.ModalTitle>{title}</S.ModalTitle>
                    <span>
                        {
                            isViewing
                                ? <Icon icon="edit" onClick={() => setViewing(false)} />
                                : <Icon icon="view" onClick={() => setViewing(true)} />
                        }
                        <Icon icon="close" className="ml-1" onClick={close} />
                    </span>
                </S.ModalHeaderInner>
            </S.ModalHeader>
            <S.ModalBody>
                {
                    isViewing
                        ? <ViewJob job={job} />
                        : <EditJob job={job} close={close} />
                }
            </S.ModalBody>
        </>
    )
}

const openViewEditJob = (isViewing: boolean, job: Job) => {
    const Component = ({ close }: { close: () => void }) => (
        <ViewEditJob
            job={job}
            isViewing={isViewing}
            close={close}
        />
    )
    return addModal({
        Component,
    })
}

export default openViewEditJob
